import { Box } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants/primitives';

export const Container = Box.withConfig({
  backgroundColor: 'white',
  borderRadius: 10,
  padding: '$6',
  margin: '$6',
  marginBottom: '$5',
  minHeight: '$40',
});

export const SwitchContainer = Box.withConfig({
  flex: '1',
  flexDirection: 'row',
  width: 'full',
  maxHeight: '$13.5',
});

export const LeftContainer = Box.withConfig({
  width: '1/2',
  flexDirection: 'row',
});

export const RightContainer = Box.withConfig({
  width: '1/2',
  padding: '$0.5',
  flexDirection: 'row-reverse',
});

export const NewText = Box.withConfig({
  width: '46px',
  height: '26px',
  _text: {
    color: 'white',
    textTransform: 'uppercase',
  },
  backgroundColor: primitive.bk.$bbqBrown,
  borderRadius: 6,
  paddingLeft: '$1.5',
  paddingTop: '$0.5',
  marginRight: '$1.5',
});

export const QuickPay = Box.withConfig({
  _text: { fontSize: 'lg', fontWeight: 'bold' },
});

export const PaymentContainer = Box.withConfig({
  marginTop: '$5',
});

export const PayWithEase = Box.withConfig({
  marginTop: '$5',
});
